import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { coreAllSalesforceOrganizationsReducers, coreAllSalesforceOrganizationsWatchers } from './all';
import { coreSyncSecurityAlertsPostSliceReducers, coreSyncSecurityAlertsPostSliceWatchers } from './sync';

export const coreSalesforceOrganizationsReducers = combineReducers({
	all: coreAllSalesforceOrganizationsReducers,
	syncSecurityAlerts: coreSyncSecurityAlertsPostSliceReducers
});

export const coreSalesforceOrganizationsWatchers = combineAllWatchers([
	coreAllSalesforceOrganizationsWatchers,
	coreSyncSecurityAlertsPostSliceWatchers
]);
